import { createTRPCReact } from "@trpc/react-query";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import type { StudioAppRouter } from "@truman/lambda/api/studio-trpc/main";

export const trpc = createTRPCReact<StudioAppRouter>();

export type RouterInputs = inferRouterInputs<StudioAppRouter>;
export type RouterOutputs = inferRouterOutputs<StudioAppRouter>;
